import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { t } from "ttag";

import { templates } from "@reactivated";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import logo from "../../../static/img/global/cocoon-logo.svg";
import iconQuestionMarkCircle from "../../assets/svg/question-mark-circle.svg";

import styles from "./index.module.scss";

const Logo = (props: { linkURL: string }) => (
    <a className="logo" href={props.linkURL} title={t`Cocoon By Sealy`}>
        <picture>
            <SVG
                className="header-brand-logo"
                src={logo}
                title={t`Cocoon By Sealy`}
            />
        </picture>
    </a>
);

export const CheckoutHeader = (
    props: Immutable<templates.CheckoutHeaderTemplate>,
): React.JSX.Element => {
    const secureCheckout = richT(t`<secure>SECURE</secure> CHECKOUT`, {
        secure: (children) => (
            <span className={styles.titleBold}>{children}</span>
        ),
    });
    return (
        <header>
            <nav className={styles.checkoutHeader}>
                <div className="main-container">
                    <div className={styles.container}>
                        <a
                            className={styles.screenReaderSkip}
                            href="#main-content"
                        >
                            {t`Skip to main content`}
                        </a>
                        <Logo linkURL={props.root_page_url} />
                        <div className={styles.title}>{secureCheckout}</div>
                    </div>
                    <div className={styles.containerRight}>
                        <div>
                            <CartReferenceNumber
                                encodedBasketID={props.encoded_basket_id}
                                phoneNumber={props.support_website_phone_number}
                                helpIcon={iconQuestionMarkCircle}
                            />
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};
